<div class="sticky-widget__content" #content stickyThing [spacer]="observer" [marginTop]="96">
  <ng-content></ng-content>
</div>
<div class="sticky-widget__observer" #observer></div>
